import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import {
  SkillDocumentResponse,
  SkillSpecializationResponse,
} from '../../../models/skill-learning.model';
import { TheoryLevelSavePayload } from '../theory-level-editor/theory-level-editor.component';
import { PracticeLevelSavePayload } from '../practice-level-editor/practice-level-editor.component';

export type EditSpecializationLevelTab = 'level1' | 'level2' | 'level3';
type SkillDocumentInput = SkillDocumentResponse | null;
type SkillSpecializationInput = SkillSpecializationResponse | null;

@Component({
  selector: 'app-edit-specialization-levels-page',
  templateUrl: './edit-specialization-levels-page.component.html',
  styleUrls: ['./edit-specialization-levels-page.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditSpecializationLevelsPageComponent {

  @Input() specialization: SkillSpecializationInput = null;
  @Input() theoryDocument: SkillDocumentInput = null;
  @Input() theoryDocumentFileId: string | null = null;
  @Input() practice2Document: SkillDocumentInput = null;
  @Input() practice2DocumentFileId: string | null = null;
  @Input() practice3Document: SkillDocumentInput = null;
  @Input() practice3DocumentFileId: string | null = null;
  @Input() isSubmitting: boolean = false;

  @Output() theoryLevelSaved = new EventEmitter<TheoryLevelSavePayload>();
  @Output() practiceLevel2Saved = new EventEmitter<PracticeLevelSavePayload>();
  @Output() practiceLevel3Saved = new EventEmitter<PracticeLevelSavePayload>();
  @Output() documentDownloadRequested = new EventEmitter<number>();

  activeTab: EditSpecializationLevelTab = 'level1';

  selectTab(tab: EditSpecializationLevelTab): void {
    this.activeTab = tab;
  }

  onTheorySaved(payload: TheoryLevelSavePayload): void {
    this.theoryLevelSaved.emit(payload);
  }

  onPractice2Saved(payload: PracticeLevelSavePayload): void {
    this.practiceLevel2Saved.emit(payload);
  }

  onPractice3Saved(payload: PracticeLevelSavePayload): void {
    this.practiceLevel3Saved.emit(payload);
  }

  requestTheoryDocument(): void {
    this.documentDownloadRequested.emit(1);
  }

  requestPractice2Document(): void {
    this.documentDownloadRequested.emit(2);
  }

  requestPractice3Document(): void {
    this.documentDownloadRequested.emit(3);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/edit-specialization-levels-page/edit-specialization-levels-page.component.ts